import React from 'react';
import { CtaButton } from './CtaButton';
import { AUTHOR_IMAGE, authorQuestions } from '../data/content';
export function AuthorMessage() {
  return <section className="bg-ink px-4 py-16 sm:py-20" aria-labelledby="author-title" data-id="element-19" data-mp="3m7o9eo2hu08d">
      <div className="mx-auto max-w-5xl md:grid md:grid-cols-[0.8fr_1.2fr] md:items-start md:gap-12" data-id="element-20" data-mp="3v9i179gojfk">
        <figure className="md:sticky md:top-8" data-id="element-21" data-mp="3w0dgl6r0grxw">
          <img src={AUTHOR_IMAGE} alt="Jason Mitchell, automotive electronics specialist, in his workshop" className="aspect-[4/5] w-full rounded-2xl object-cover object-top" loading="lazy" data-id="element-22" data-mp="389hglmceiqfk" />
          <figcaption className="mt-3 text-center" data-id="element-23" data-mp="3hbz6qbv6g37u">
            <span className="block font-display text-2xl font-extrabold uppercase text-white" data-id="element-24" data-mp="3cb2zbobm9yxo">Jason Mitchell</span>
            <span className="text-sm text-amber" data-id="element-25" data-mp="wjf8man752nb">Automotive Electronics Specialist</span>
          </figcaption>
        </figure>

        <div className="mt-10 md:mt-0" data-id="element-26" data-mp="rl3xlwl60m3i">
          <p className="font-display text-lg font-bold uppercase tracking-wider text-amber" data-id="element-27" data-mp="cmxk18pti15a">A message from Jason Mitchell</p>
          <h2 id="author-title" className="mt-2 font-display text-4xl font-extrabold uppercase leading-[1.02] text-white sm:text-5xl" data-id="element-28" data-mp="gn7qemhiutko">
            Why the OBD2 Diagnostic Blueprint™ was created
          </h2>

          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-mist" data-id="element-29" data-mp="qkccynfa4r20">
            <p data-id="element-30" data-mp="3p5vs4v2oxtw7">When you’re working with modern automotive electronics, one thing becomes clear:</p>
            <p className="text-white" data-id="element-31" data-mp="3u3f57rnnk0mk">
              Having access to diagnostic information doesn’t automatically mean you know what to do with it.
            </p>
            <p data-id="element-32" data-mp="7nud1iqa1kuo">
              A scanner can retrieve fault codes. It can display live data. But it cannot replace the reasoning
              required to investigate the underlying problem. When you retrieve a code, there are several important
              questions to consider:
            </p>
          </div>

          <ul className="mt-5 space-y-2 border-l-4 border-amber pl-5" data-id="element-33" data-mp="33ane4yghv6tm">
            {authorQuestions.map(q => <li key={q} className="text-[17px] font-semibold text-white" data-id="element-34" data-mp="2z9v25xg8mntn">
                {q}
              </li>)}
          </ul>

          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-mist" data-id="element-35" data-mp="382yeg2f5cump">
            <p data-id="element-36" data-mp="38512igwqodos">
              The Blueprint is organized around those questions. Rather than presenting fault codes as automatic
              instructions to replace parts, it focuses on understanding diagnostic information and applying a
              structured investigation process.
            </p>
            <p className="font-display text-2xl font-bold uppercase leading-tight text-white" data-id="element-37" data-mp="2pc6w4bd6ltw6">
              My goal: help you move from reading a fault code to understanding how to investigate it.
            </p>
            <p data-id="element-38" data-mp="4m81f3l5dhbi">
              Not through shortcuts that promise to solve every problem instantly — but through clearer reasoning,
              better organization, and appropriate diagnostic verification. Whether you’re building your skills or
              refining your process, I want this to be a framework you return to whenever you need it.
            </p>
            <p className="font-semibold text-white" data-id="element-39" data-mp="1dkzhnde4fwy3">— Jason Mitchell</p>
          </div>

          <CtaButton className="mt-10" label="Start with Jason’s Blueprint" sub="Instant access · $27 one-time" data-id="element-40" data-mp="1ii9f9gbnzex0" />
        </div>
      </div>
    </section>;
}